<template>
    <div class="card" v-if="nav">
        <div class="">

            <span class="title">
                {{ $t('simulations.last-simulation') }}:
            </span>

            <router-link :to="'/astral/ui/dashboard/cohorts/' + nav.registration.cohort_id">
                {{ nav.registration.cohort.name }}
            </router-link>
            >
            <router-link :to="'/astral/ui/dashboard/registrations/' + nav.registration.id + '/cohorts/' + nav.registration.cohort_id">
                {{ nav.registration.degree.name }}
            </router-link>
            >
            <router-link :to="'/astral/ui/dashboard/registrations/' + nav.registration.id + '/simulations/' + nav.simulation.id + '/cohorts/' + nav.registration.cohort_id"
                v-if="$permissions.hasRight('dashboard.sessions.read')"
            >
                {{ nav.simulation.name }}
            </router-link>
            <span class="disabled" v-else>
                {{ nav.simulation.name }}
            </span>

        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                nav: null,
            }
        },

        created() {
            this.nav = this.$navigation.getLastSimulation()
        },

        watch: {
            nav(val) {
                if (val) {
                    this.$emit("show")
                }
            }
        }
    }
</script>

<style scoped>

    .card {
        padding: 1.0rem 1.5rem;
    }
    .title {
        font-weight: 600;
        line-height: 1.5;
        color: #32325d;
        text-transform: uppercase;
        padding-right: 10px;
    }
    .disabled {
        padding-left: 10px;
        color: #93939c;
    }
    a {
        padding-left: 10px;
        padding-right: 10px;
        color: #32325d;
    }
    a:hover {
        padding-left: 10px;
        padding-right: 10px;
        color: #233dd2;
    }

</style>